import common from "@page/common/js/common";

import Slick from "@global/vendors/vue-slick";

import indexTmpl from "@page/lookbook/js/indexTmpl";
import IGPOPUP_TMPL from "@page/lookbook/js/lookbookPopupTmpl";
import NewImage from "@global/components/global/image";

const igPopup = {
	template: IGPOPUP_TMPL,
	props: ["item", "isopen", "stop"],
	data: function () {
		return {
			slideOpts: {
				slidesToShow: 2,
				slidesToScroll: 2,
				arrows: true,
			},
		};
	},
	components: {
		NewImage,
		Slick,
	},
	methods: {
		closePopup: function () {
			this.$emit("close");
		},
		goPost: function (val) {
			this.$emit("gopost", val);
		},
		next() {
			this.$refs.slickig.next();
		},

		prev() {
			this.$refs.slickig.prev();
		},

		reInit() {
			// Helpful if you have to deal with v-for to update dynamic lists
			this.$nextTick(() => {
				// this.$refs.slickig.reSlick();
				if (this.$refs.slickig) {
					console.log($(".product-slide"));
					$(".product-slide").not(".slick-initialized").slick(this.slideOpts);
					// $(this.$refs.slickig).create(this.slideOpts);
				}
			});
		},
		// Events listeners
		handleAfterChange(event, slick, currentSlide) {
			// console.log('handleAfterChange', event, slick, currentSlide);
		},
		handleBeforeChange(event, slick, currentSlide, nextSlide) {
			// console.log('handleBeforeChange', event, slick, currentSlide, nextSlide);
		},
		handleBreakpoint(event, slick, breakpoint) {
			// console.log('handleBreakpoint', event, slick, breakpoint);
		},
		handleDestroy(event, slick) {
			// console.log('handleDestroy', event, slick);
		},
		handleEdge(event, slick, direction) {
			// console.log('handleEdge', event, slick, direction);
		},
		handleInit(event, slick) {
			// console.log('handleInit', event, slick);
		},
		handleReInit(event, slick) {
			// console.log('handleReInit', event, slick);
		},
		handleSetPosition(event, slick) {
			// console.log('handleSetPosition', event, slick);
		},
		handleSwipe(event, slick, direction) {
			// console.log('handleSwipe', event, slick, direction);
		},
		handleLazyLoaded(event, slick, image, imageSource) {
			// console.log('handleLazyLoaded', event, slick, image, imageSource);
		},
		handleLazeLoadError(event, slick, image, imageSource) {
			// console.log('handleLazeLoadError', event, slick, image, imageSource);
		},
	},
	beforeUpdate() {
		// $(this.$refs.slick.$el).hide();
		console.log(this.$refs);
		if (this.$refs.slickig) {
			this.$refs.slickig.destroy();
		}
	},
	updated() {
		var _this = this;

		setTimeout(function () {
			// _this.$nextTick(function () {
			// 	// if (_this.slideOpts.length!==0) {
			// 	// 	_this.$refs.slick.create(_this.slideOpts);
			// 	// 	$(this.$refs.slick.$el).fadeIn("slow");
			// 	// }
			// 	_this.$refs.slick.reInit()
			// });
			_this.reInit();
		}, 100);
	},
};

const IGapp = {
	template: indexTmpl,
	data: {
		nowPopupID: null, //for popup show/off,
		nowPopupIndex: null,
		popupPost: null,
		popupIsOpen: false,
		nowPage: 1,
		pagePosts: [],
		pageInfo: null,
		posts: [],
		postSize: 18, //一頁幾筆
		isLoading: false,
		runLoading: false,
		dataisload: false,
		removeMoreBtn: false,
		scrollY: 0,
		nowLink: window.location.href,
		refinedH: "33.33%",
	},
	components: {
		igPopup,
	},
	created: function () {
		var _this = this;
		var campaignTag = this.getTagName();
		$.ajax({
			type: "GET",
			url: API_URL.IG_STYLE + "?Tag=" + campaignTag,
			dataType: "json",
			xhrFields: {
				withCredentials: true,
			},
			error: function () {
				console.log("error");
			},
			success: function (res) {
				if (res.Code === 200) {
					_this.posts = res.Response.Posts;
					_this.pageInfo = res.Response.Campaign;
					_this.loadPageDatas();
					_this.dataisload = true;
					_this.initPopup();
				} else {
					AlertDialog.alert("系統忙線中，請稍後");
				}
			},
		});

		this.$nextTick(() => {
			setTimeout(() => {
				// console.log($(".ig-box:not(.ig-box-l)"))
				this.refinedH = Math.round($(".ig-box-l").outerHeight());
				// $(".ig-box:not(.ig-box-l)").css('width', );
				console.log(this.refinedH);
			}, 1000);
		});
	},
	mounted: function () {
		var _this = this;
		this.bindHistory();
		window.addEventListener("scroll", this.scrollEvent);
	},
	watch: {
		nowPopupIndex: function (index) {
			var _this = this;
			if (this.posts[index] === undefined) {
				this.closePopup();
				return;
			}
			this.popupIsOpen = true;
			this.popupPost = this.posts[index];
			// this.setRelatedItemsScroll();
		},
	},
	methods: {
		runSlide: function () {},
		getTagName: function () {
			var pathname = window.location.pathname;
			if (pathname.substring(pathname.indexOf("ig/") + 3, pathname.length).indexOf("/") !== -1) {
				var tagName = pathname.substring(pathname.indexOf("ig/") + 3, pathname.lastIndexOf("/"));
			} else {
				var tagName = pathname.substring(pathname.indexOf("ig/") + 3, pathname.length);
			}
			return tagName;
		},
		initPopup: function () {
			var pathname = window.location.pathname;
			var pathID = pathname.substring(pathname.lastIndexOf("/") + 1, pathname.length);
			var _this = this;
			if (pathname.substring(4, pathname.length).indexOf("/") !== -1) {
				// 有ID編號
				this.posts.forEach(function (el, index) {
					if (el.ID === parseInt(pathID)) {
						_this.openPopup(index, pathID);
					}
				});
			}
		},
		bindHistory: function () {
			var _this = this;

			console.log("bind");

			if (History.Adapter !== undefined) {
				History.Adapter.bind(window, "statechange", function () {
					var pidx = History.getState().data.p_index;
					_this.scrollY = window.scrollY;
					_this.nowPopupIndex = pidx;
					// _this.nowLink = window.location.href;
					console.log("chage");
				});
			}
		},
		loadPageDatas: function () {
			this.isLoading = true;
			for (var i = (this.nowPage - 1) * this.postSize; i < this.nowPage * this.postSize; i++) {
				if (this.posts[i] !== undefined) this.pagePosts.push(this.posts[i]);
				if (i === this.nowPage * this.postSize - 1) this.isLoading = false;
				if (i === this.posts.length - 1) this.reachLastPage();
			}
		},
		reachLastPage: function () {
			this.runLoading = false;
			this.removeMoreBtn = true;
			window.removeEventListener("scroll", this.scrollEvent);
		},
		scrollEvent: function () {
			var $window = $(window),
				$document = $(document);

			if (!this.isLoading) {
				var winHeight = window.innerHeight ? window.innerHeight : $window.height(), // iphone fix
					closeToBottom = $window.scrollTop() + winHeight > $document.height() - 1500;
				if (closeToBottom) {
					// Get datas and add them to the bottom of the grid
					this.nowPage++;
					this.loadPageDatas();
				}
			}
		},
		openPopup: function (index, pid) {
			var pathname = window.location.pathname;
			if (pathname.substring(4, pathname.length).indexOf("/") !== -1) {
				// 有ID編號
				History.pushState({ p_index: index, p_id: pid }, $("title").html(), window.location.href);
				console.log("1");
			} else {
				History.pushState({ p_index: index, p_id: pid }, $("title").html(), window.location.pathname + "/" + pid);
				console.log("2");
			}
			$("body").addClass("lock-page");
		},
		closePopup: function () {
			this.popupIsOpen = false;
			var id = History.getState().data.p_id;
			History.pushState({ p_index: null, p_id: null }, $("title").html(), window.location.href.replace("/" + id, ""));
			$("body").removeClass("lock-page");
		},
		changeNowIndex: function (val) {
			var nextIdx = this.nowPopupIndex + 1;
			var preIdx = this.nowPopupIndex - 1;
			var nowID = this.posts[this.nowPopupIndex].ID;
			var nextIdx = this.nowPopupIndex + 1 == this.posts.length ? this.nowPopupIndex : this.nowPopupIndex + 1;
			var preIdx = this.nowPopupIndex - 1 == -1 ? this.nowPopupIndex : this.nowPopupIndex - 1;
			var nextID = this.posts[this.nowPopupIndex + 1] == undefined ? undefined : this.posts[this.nowPopupIndex + 1].ID;
			var preID = this.posts[this.nowPopupIndex - 1] == undefined ? undefined : this.posts[this.nowPopupIndex - 1].ID;

			if (val === "next" && this.nowPopupIndex + 1 !== this.posts.length) {
				History.pushState(
					{ p_index: nextIdx, p_id: nextID },
					$("title").html(),
					window.location.href.replace("/" + nowID, "/" + nextID)
				);
			} else if (val === "pre" && this.nowPopupIndex - 1 !== -1) {
				History.pushState(
					{ p_index: preIdx, p_id: preID },
					$("title").html(),
					window.location.href.replace("/" + nowID, "/" + preID)
				);
			} else {
				this.closePopup();
			}
		},
	},
	beforeDestroy: function () {
		window.removeEventListener("scroll");
	},
};

const app = new Vue(
	Object.assign(
		{
			el: "#ig-app",
		},
		IGapp
	)
);
